<template>
  <div class="homepromo-wrapper" ref="emblaNode">
    <div class="embla__container">
      <div
        v-for="banner in promoBanners"
        :key="banner._id"
        class="embla__slide"
      >
        <div class="banner-card">
          <img
            :src="backendUrl + banner.imageUrl"
            :alt="banner.title"
            class="banner-image"
          />
          <div class="banner-overlay">
            <h2 class="banner-title">{{ banner.title }}</h2>
            <a :href="banner.link" class="banner-button small">
              {{ $t("home.Go") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import EmblaCarousel from "embla-carousel";

const backendUrl =
  process.env.VUE_APP_BACKEND_URL || "https://play.rivobit.com";
const promoBanners = ref([]);
const emblaNode = ref(null);

onMounted(async () => {
  try {
    const res = await axios.get("/public/banners");
    promoBanners.value = res.data.filter((b) => b.position === "HomePromo");
  } catch (err) {
    console.error("API ERROR", err);
  }

  if (emblaNode.value && promoBanners.value.length > 0) {
    const embla = EmblaCarousel(emblaNode.value, {
      loop: true,
      align: "start",
    });

    // autoplay 2sn
    let autoplayInterval = setInterval(() => {
      if (embla.canScrollNext()) {
        embla.scrollNext();
      } else {
        embla.scrollTo(0);
      }
    }, 5000);

    embla.on("destroy", () => clearInterval(autoplayInterval));
  }
});
</script>

<style scoped>
.homepromo-wrapper {
  width: 100%;
  overflow: hidden;
  padding: 12px 0;
  padding-left: 10px;
  padding-right: 10px;
}

.embla__container {
  display: flex;
}

.embla__slide {
  flex: 0 0 auto;
}

/* PC görünümü */
@media (min-width: 769px) {
  .embla__slide {
    flex: 0 0 auto;
    min-width: 280px;
    max-width: 100%;
    margin-right: 16px;
  }
  .banner-card {
    height: 140px;
  }
}

/* Mobil görünümü (yan yana 2 tane, yazısız) */
@media (max-width: 768px) {
  .embla__slide {
    flex: 0 0 50%; /* tam 2 tane görünür */
  }
  .banner-card {
    height: 100px; /* daha alçak */
  }
  .banner-title {
    display: none; /* yazılar gizlendi */
  }
  .banner-button.small {
    position: absolute;
    bottom: 8px;
    right: 8px;
  }
}

/* Kart */
.banner-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
 
}

/* Görsel */
.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Overlay */
.banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 8px 12px;
  color: #fff;
 
}

/* Başlık (sadece PC için) */
.banner-title {
  font-size: clamp(0.9rem, 2vw, 1.2rem);
  font-weight: 700;
  margin: 0 0 4px 0;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);
}

/* Buton */
.banner-button.small {
  display: inline-block;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 0.8rem;
  color: #fff;
  border-radius: 10px;
  background: var(--buttonyellow);
  box-shadow: rgb(197, 106, 24) 0px -2px 0px inset,
    rgb(255, 234, 47) 0px 1px 0px inset;
  text-shadow: 0 0 3px #c56a18;
}
</style>
